export default "/images/vendor/flag-icon-css/flags/1x1/gp.svg?30b1d26cfe9f458611e26248fadb490c";